import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";

import GuideIMG from "../../../../assets/guide.png";
import GuideComponent from "../../../components/materialui/Shared/GuideComponent";


const useStyles = makeStyles(() => ({

    message: {
        fontSize: '1em',
        color: '#000',
        fontWeight: 'lighter',
    },

    documentItem: {
        fontSize: '0.8em',
        color: '#231F20',
        font: 'Inter',
        fontWeight: 'lighter',
    },

    image: {
        width: '40%',
        display: "block",
        margin: "0 auto"
    },
}));


export default function GuideStep() {

    const classes = useStyles();

    return (
        <div>
            <GuideComponent title="Guia de documentação">
                <Grid container spacing={2} component="span">

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item sm={12}>
                                <img src={GuideIMG} className={classes.image} alt="Imagem ilustrativa de um guia" />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Antes de iniciar o preenchimento do formulário, certifique-se de ter em mãos os documentos listados abaixo, que deverão ser anexados à solicitação. Para documentos com frente e verso, recomendamos que ambos sejam digitalizados e anexados em um único arquivo.
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Documentos necessários para médicos:
                        </Typography>
                        <Typography variant="body2" component="span" className={classes.documentItem}>
                            <p> - Carteira do Conselho </p>
                            <p> - Título de Especialista <strong>(frente e verso)</strong></p>
                            <p> - Certidão de Ética Profissional (emitida pelo site do CREMESP)</p>
                            <p> - Relatório Médico e de Materiais</p>                            
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Documentos necessários para outros profissionais:
                        </Typography>
                        <Typography variant="body2" component="span" className={classes.documentItem}>
                            <p> - Carta de autorização do cirurgião titular. </p>
                            <p> - Certificado de Instrumentação ou da Área de atuação <strong>(frente e verso)</strong> </p>
                            <p> - CPF e RG; </p>

                        </Typography>
                    </Grid>

                </Grid>
            </GuideComponent>
        </div>

    )
}